module.exports = __webpack_public_path__ + "static/media/chapter-two-group.7d693e29.png";